// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2u-3";
export var dialog = "_2u-0";
export var divClassnameSwatch = "_2u-8";
export var flexSwatch = "_2u-4";
export var header = "_2u-1";
export var styleAttributeSwatch = "_2u-7";
export var swatch = "_2u-2";
export var textHeaderSwatch = "_2u-5";
export var webSwatch = "_2u-6";